module.exports = __webpack_public_path__ + "static/media/katapulk_logo.a0f1c70d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/katapulk_logo.svg
 ** module id = 463
 ** module chunks = 0
 **/